import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import styles from './SuperPowerShortLanderMobile.module.scss';
import { useLanderControls } from '../LanderContext';

export const SuperPowerShortLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-superpowershort-lander-top-hero-1.jpg'} title={'SuperPower Short'} subTitle={'The next generation of shapewear.'}>
          <HeroCallout
            orderIndex={0}
            label="Waist stays up"
            labelColor={'black'}
            inlineStyles={{
              mobile: {
                right: `5%`,
                top: `49.8%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={<>Posture Support</>}
            labelColor={'black'}
            inlineStyles={{
              mobile: {
                left: `1%`,
                bottom: `43%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Targeted
                <br /> Compression
              </>
            }
            titleStyles={{ lineHeight: '22px', marginTop: 6, textAlign: 'center' }}
            inlineStyles={{
              mobile: {
                left: `40%`,
                top: `62%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={3}
            label={<>BoostBands</>}
            labelColor={'black'}
            inlineStyles={{
              mobile: {
                left: `5%`,
                bottom: `20%`,
                flexDirection: 'row',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-sps-desktop-1.jpg',
              title: 'Doesn’t roll down',
              description: 'Flexible boning keeps the garment from rolling down.',
            },
            {
              imgName: 'feature-sps-desktop-2.jpg',
              title: 'Targeted compression',
              description: 'Varied levels of compression shape without squeezing.',
            },
            {
              imgName: 'feature-sps-desktop-3.jpg',
              title: 'Booty lifting',
              description: 'BoostBands shape thighs and lift the bottom.',
            },
          ]}
        />
        <CardTitle text="Innovation you can see" style={{ paddingTop: 0 }} />
        <div className={styles.comparison}>
          <img src={assetPathFn('superpower-short-before-after.jpg')} alt="comparison" />
          <div>
            <div>competitor</div>
            <div>
              superpower <br />
              short
            </div>
          </div>
        </div>
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.SuperPowerShort]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default SuperPowerShortLanderMobile;
